<template>
  <button-dialog-container
    :btn-icon="icon"
    :no-btn="true"
    :size="getSize"
    :only-icon="true"
    :width-dialog="800"
    :dialog-viewer.sync="dialog"
    @ok-pushed="returnListPdf"
    @outside-click="outsideClick"
    @cancel-pushed="outsideClick"
  >
    <v-container class="mt-4">
      <v-row>
        <v-col cols="6">
          <v-row class="text-center justify-center">
            <v-img
              v-if="listPdf.length != 0"
              contain
              max-height="500"
              max-width="350"
              :lazy-src="picture"
              :src="picture"
            />
          </v-row>
          <v-row class="marginZero mt-7 mb-n14">
            <v-col>
              <v-btn
                icon
                @click="pagePrevious()"
              >
                <v-icon>mdi-chevron-left</v-icon>
              </v-btn>
            </v-col>
            <v-col>
              <v-select
                v-model="page"
                :items="btnPage"
                item-text="name"
                item-value="value"
                :heigth="10"
                dense
                outlined
                bottom
                @change="clickPage(page)"
              />
            </v-col>
            <v-col class="text-end justify-end">
              <v-btn
                icon
                @click="pageNext()"
              >
                <v-icon>mdi-chevron-right</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-row />
        </v-col>
        <v-col cols="1">
          <v-divider
            class="ml-4"
            vertical
          />
        </v-col>
        <v-col cols="5">
          <v-row>
            <v-subheader>
              {{ $t("creation.tools.dialog.pdf.choose-page") }}
            </v-subheader>
            <v-select
              v-model="structure"
              :items="btnStructure"
              item-text="name"
              item-value="value"
              dense
              outlined
              :label="$t('creation.tools.dialog.pdf.structure')"
              @change="clickStructure()"
            />
          </v-row>
          <!-- DIVIDER -->
          <v-row class="mb-2 mt-n2">
            <v-divider />
          </v-row>
          <v-row v-if="structure == 1">
            <v-col>
              <v-select
                v-model="pageStart"
                :items="cbxStart"
                item-text="name"
                item-value="value"
                dense
                outlined
                :label="$t('creation.tools.dialog.pdf.start')"
                @change="pageToPage()"
              />
            </v-col>
            <v-col>
              <v-select
                v-model="pageEnd"
                :items="cbxEnd"
                item-text="name"
                item-value="value"
                dense
                outlined
                :label="$t('creation.tools.dialog.pdf.end')"
                @change="pageToPage()"
              />
            </v-col>
          </v-row>
          <v-row v-if="structure == 2">
            <v-col>
              <v-row
                v-for="(group, index) in numberOfGroupComputer"
                :key="index"
              >
                <div class="col-5">
                  <v-select
                    v-model="groupPage[group - 1].cbxStart"
                    :items="backupPage"
                    item-text="name"
                    :value="groupPage.cbxStart"
                    dense
                    outlined
                    :label="$t('creation.tools.dialog.pdf.start')"
                    @change="(cbxStart) => startPagePerso(group, cbxStart)"
                  />
                </div>
                <div class="col-5">
                  <v-select
                    v-model="groupPage[group - 1].cbxEnd"
                    :items="backupPage"
                    item-text="name"
                    item-value="value"
                    :value="groupPage.cbxEnd"
                    dense
                    outlined
                    :label="$t('creation.tools.dialog.pdf.end')"
                    @change="(cbxEnd) => endPagePerso(group, cbxEnd)"
                  />
                </div>
                <div class="col-1">
                  <v-btn
                    icon
                    dense
                  >
                    <v-icon
                      dense
                      medium
                      @click="controlGroup(group)"
                    >
                      {{ group != numberOfGroup ? "mdi-minus-box-multiple-outline" : "mdi-plus-box-multiple-outline" }}
                    </v-icon>
                  </v-btn>
                </div>
              </v-row>
              {{ picture }}
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </button-dialog-container>
</template>

<script>
// Libs
import buttonDialogContainer from "../Common/ButtonDialogContainer";

export default {
  components: {
    buttonDialogContainer,
  },
  props: {
    currentObject: {
      type: Object,
      default: () => {},
    },
    icon: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
    color: {
      type: String,
      default: "",
    },
    toolName: {
      type: String,
      default: "",
    },
    getSize: {
      type: Number,
      default: 25,
    },
  },
  data() {
    return {
      dblclick: false,
      thePath: "",
      numPage: 0,
      data: [1], //sample data
      numberOfGroup: 1,
      page: 1,
      entraxe: 1,
      pageStart: 1,
      pageEnd: 1,
      cbxStart: [],
      cbxEnd: [],
      btnPage: [],
      structure: 0,
      backupPage: [],
      btnStructure: [
        { value: 0, name: this.$t("creation.tools.dialog.pdf.all") },
        { value: 1, name: this.$t("creation.tools.dialog.pdf.page-by-page") },
        { value: 2, name: this.$t("creation.tools.dialog.pdf.personalize") },
      ],
      btnAlign: [{ value: "left", name: this.$t("align.left") }],
      listPdf: [],
      nbPagePdf: 0,
      groupPage: [],
      dialog: false,
      dirName: "",
    };
  },
  computed: {
    numberOfGroupComputer: {
      get() {
        return this.numberOfGroup;
      },
    },
    open() {
      return this.$store.state.widget.openEditPdf;
    },
    getPdfCreated() {
      return this.$store.state.creation.pdfCreated;
    },
    picture: {
      get() {
        return this.listPdf[this.page - 1];
      },
    },
  },
  watch: {
    getPdfCreated: function () {
      if (this.getPdfCreated !== "" && this.getPdfCreated !== undefined) {
        const files = this.getPdfCreated.files;

        if (files.length > 0) {
          this.dirName = this.getPdfCreated.dirname;
          this.dialog = true;

          this.$store.dispatch("pdfReset").creation;

          this.listPdf = files.map((pdf) => {
            return (
              this.$store.state.config.dirs.root +
              "mediacenter/" +
              this.$store.state.user.socId +
              "/PDF/" +
              this.dirName +
              "/" +
              pdf
            );
          });

          this.generatedValue();
        }
      }
    },
    open: function () {
      if (this.open) {
        // TODO: MAYBE PATH BETTER ???
        const tempo = this.currentObject.source[0].split("\\");

        this.pathFile =
          this.$store.state.config.dirs.root +
          "mediacenter/" +
          this.$store.state.user.socId +
          "/PDF/" +
          tempo[tempo.indexOf("PDF") + 1];
        this.dialog = true;
        this.dblclick = true;
        this.generatedValue();
        this.$store.dispatch("editClose").widget;
      }
    },
  },
  methods: {
    generatedValue() {
      this.nbPagePdf = this.listPdf.length;

      for (let i = 1; i < this.nbPagePdf + 1; i++) {
        const tempo = i + "/" + this.nbPagePdf;
        this.btnPage.push({
          value: i,
          name: tempo,
          path: this.listPdf[i - 1],
        });
      }

      this.backupPage = this.btnPage;
      this.cbxStart = this.btnPage;
      this.cbxEnd = this.btnPage;

      this.groupPage = [
        {
          id: 1,
          cbxStart: this.backupPage[0].value,
          cbxEnd: this.backupPage[this.nbPagePdf - 1].value,
        },
      ];
      this.pageEnd = this.nbPagePdf;

      this.btnPage.sort((a, b) => {
        return a.value - b.value;
      });
    },
    clickPage(val) {
      this.numPage = val - 1;
    },
    outsideClick() {
      this.page = 1;
      this.numberOfGroup = 1;
      this.numPage = 0;
      this.nbPagePdf = 0;
      this.structure = 0;
      this.btnPage = [];
      this.groupPage = [];
    },
    pagePrevious() {
      if (this.numPage > 0 && this.numPage <= this.btnPage.length - 1) {
        this.numPage--;
        this.page = this.btnPage[this.numPage].value;
      }
    },
    pageNext() {
      if (this.numPage < this.btnPage.length - 1) {
        this.numPage++;
        this.page = this.btnPage[this.numPage].value;
      } else {
        this.numPage = 0;
        this.page = this.btnPage[0].value;
      }
    },
    pageToPage() {
      this.btnPage = this.backupPage.slice(this.pageStart - 1, this.pageEnd);
      this.page = this.btnPage[0].value;
    },
    startPagePerso(group, page) {
      this.groupPage[group - 1].cbxStart = page;
      this.reconstruct();
    },
    endPagePerso(group, page) {
      this.groupPage[group - 1].cbxEnd = page;
      this.reconstruct();
    },
    controlGroup(group) {
      // TODO: SEE WHAT THE F**K IS DOING
      if (group != this.numberOfGroup) {
        this.numberOfGroup--;
        delete this.data[group - 1];
        delete this.groupPage[group - 1];
        const tempo = [];
        this.groupPage.forEach((element) => {
          tempo.push(element);
        });
        this.groupPage = tempo;
      } else {
        this.numberOfGroup++;
        this.data.push(this.numberOfGroup);
        this.groupPage.push({
          id: this.numberOfGroup,
          cbxStart: this.backupPage[0].value,
          cbxEnd: this.backupPage[this.nbPagePdf - 1].value,
        });
      }
      this.reconstruct();
    },
    reconstruct() {
      const tempo = [];
      this.groupPage.forEach((element) => {
        const tempo2 = this.backupPage.slice(element.cbxStart - 1, element.cbxEnd);
        tempo2.forEach((element2) => {
          tempo.push(element2);
        });
      });
      tempo.sort(function (a, b) {
        return a.value - b.value;
      });
      this.btnPage = tempo;
      this.page = this.btnPage[0].value;
    },
    clickStructure() {
      this.btnPage.sort(function (a, b) {
        return a.value - b.value;
      });
      this.btnPage = this.backupPage;
      this.page = this.btnPage[0].value;
    },
    returnListPdf() {
      if (!this.dblclick) {
        this.$emit("update:list-pdf", this.listPdf);
      } else if (this.dblclick) {
        this.$emit("pdfEditConfig", {
          name: "pdf",
          content: this.listPdf,
          config: this.currentObject.konvaObjectOption,
        });

        this.dblclick = false;
      }

      this.outsideClick();
    },
  },
};
</script>

<style>
.marginZero {
  margin-top: 0px;
}

.separation {
  display: inline-flex;
  flex-direction: center;
  align-content: center;
  align-self: center;
}
</style>
